// MapLibre and the pmtiles protocol (about 260 KB compressed) are downloaded when the first map starts, which
// Map.vue does once the map scrolls near the viewport, instead of with the page.
let maplibrePromise = null;

export function loadMaplibre() {
  maplibrePromise ??= Promise.all([import("maplibre-gl"), import("pmtiles")]).then(
    ([{ default: maplibregl }, { Protocol }]) => {
      maplibregl.addProtocol("pmtiles", new Protocol().tile);
      return maplibregl;
    },
  );
  return maplibrePromise;
}

// Mapterhorn terrarium tiles (512px WebP) for contour lines and the styles' hillshade (`terrarium` source in
// public/styles/*.json). Both use the same URLs and max zoom, so they share tiles in the browser cache.
export const MAPTERHORN_TILES = "https://tiles.mapterhorn.com/{z}/{x}/{y}.webp";
export const MAPTERHORN_MAXZOOM = 12;

// How many zooms below the map contour lines take their elevation tiles from, or null to skip them. One zoom
// lower needs about half the Mapterhorn data of full detail (each contour tile needs its elevation tile and the 8
// around it) and looks nearly the same. On slow or data-saving connections they are coarser (3g) or left out
// (2g, Save-Data). navigator.connection is Chromium-only and an estimate, so it only ever lowers the detail.
export function contourOverzoom(connection = globalThis.navigator?.connection) {
  if (connection?.saveData || ["slow-2g", "2g"].includes(connection?.effectiveType)) {
    return null;
  }
  return connection?.effectiveType === "3g" ? 2 : 1;
}

// The Mapterhorn elevation source behind contour lines (MapContour), shared by every map: maps of the same area
// (like those on /snow-totals) download and decode each elevation tile once, in a single web worker.
let demSourcePromise = null;

export function loadDemSource() {
  demSourcePromise ??= Promise.all([loadMaplibre(), import("maplibre-contour")]).then(
    ([maplibregl, { default: mlcontour }]) => {
      const demSource = new mlcontour.DemSource({
        url: MAPTERHORN_TILES,
        encoding: "terrarium",
        maxzoom: MAPTERHORN_MAXZOOM,
        worker: true, // offload isoline computation to a web worker to reduce jank
        cacheSize: 100, // number of most-recent tiles to cache
        timeoutMs: 10_000, // timeout on fetch requests
      });
      demSource.setupMaplibre(maplibregl);
      return demSource;
    },
  );
  return demSourcePromise;
}
